<template>
  <div>
    <form-answer
      @newQuestionComment="getNextOrPrevQuestion(currentQuestionId)"
      @newAnswer="onAnswerAnswered"
      @nextOrPrevQuestion="getNextOrPrevQuestion"
      @answerRejected="getNextOrPrevQuestion(currentQuestionId)"
      @answerRetrieved="getNextOrPrevQuestion(currentQuestionId)"
      @answerMarkReplaced="getNextOrPrevQuestion(currentQuestionId)"
      @answerDeleted="getNextOrPrevQuestion(currentQuestionId)"
      @newMissingImage="getNextOrPrevQuestion(currentQuestionId)"
      @updateEnableQuestion="getNextOrPrevQuestion(currentQuestionId)"
      :checklist="checklist"
      :placeChecklist="placeChecklist"
      :currentPlaceUser="currentPlaceUser"
      :breadcrumb="breadcrumb"
      :currentQuestion="currentQuestion"
      :modelId="$route.params.id"
      :createAnswer="createAnswer"
      :rejectAnswer="rejectAnswer"
      :deleteAnswer="deleteAnswer"
      :progress="checklistProgress"
      :questions="questions"
    >
    </form-answer>
  </div>
</template>

<script>
import Breadcrumb from "@/layouts/components/content/breadcrumb/Breadcrumb.vue";
import PageTitle from "@/layouts/components/content/page-title/PageTitle.vue";
import { mapActions, mapGetters } from "vuex";
import FormAnswer from "@/view/pages/app/questions/components/FormAnswer.vue";

export default {
  components: {
    Breadcrumb,
    PageTitle,
    FormAnswer,
  },
  mounted() {
    // El listado vive en el store y sobrevive a la navegación: si no se limpia,
    // el sidebar muestra las preguntas de la plantilla anterior mientras carga
    // la nueva y deja navegar a ids que no pertenecen a esta plantilla.
    this.$store.commit("question/SET_QUESTIONS", []);
    this.getPlace(this.$route.params.id);
    this.getPlaceUsers({
      place_id: this.$route.params.id,
    });
    this.getChecklist(this.$route.params.checklistId);
    this.getQuestions({
      checklist_id: this.$route.params.checklistId,
      place_id: this.$route.params.id,
    });
    this.getCurrentQuestion();
    this.getPlaceChecklists({
      checklist_id: this.$route.params.checklistId,
      place_id: this.$route.params.id,
    });
  },
  data() {
    return {
      currentQuestion: null,
      currentQuestionId: null,
      checklistProgress: 0,
    };
  },
  methods: {
    ...mapActions({
      getPlace: "place/getPlace",
      getChecklist: "checklist/getChecklist",
      getPlaceUsers: "place/getPlaceUsers",
      getNextChecklistQuestion: "question/getNextChecklistQuestion",
      createAnswer: "question/createAnswer",
      rejectAnswer: "question/rejectAnswer",
      deleteAnswer: "question/deleteAnswer",
      getPlaceChecklistProgress: "place/getPlaceChecklistProgress",
      getQuestions: "question/getQuestions",
      getPlaceChecklists: "place/getPlaceChecklists",
    }),
    getCurrentQuestion() {
      this.getNextQuestion({
        checklist_id: this.$route.params.checklistId,
        place_id: this.$route.params.id,
      });
    },
    onAnswerAnswered() {
      this.getNextOrPrevQuestion(this.currentQuestionId);
      this.getQuestions({
        checklist_id: this.$route.params.checklistId,
        place_id: this.$route.params.id,
      });
    },
    getNextOrPrevQuestion(id, unapproved_only = undefined, direction = null) {
      if (direction === null && this.currentQuestion?.near) {
        if (id === this.currentQuestion.near[0]) {
          direction = 'prev';
        } else if (id === this.currentQuestion.near[1]) {
          direction = 'next';
        }
      }
      this.getNextQuestion({
        checklist_id: this.$route.params.checklistId,
        question_id: id,
        place_id: this.$route.params.id,
        unapproved_only,
        direction,
      });
    },
    async getNextQuestion(params) {
      const previousQuestion = this.currentQuestion;
      this.currentQuestion = null;
      const question = await this.getNextChecklistQuestion(params);
      // La acción devuelve el error de axios cuando la API responde 400/500
      // (por ejemplo al pedir una pregunta que no es de esta plantilla). Si se
      // asigna tal cual, FormAnswer revienta al renderizar y la vista queda en
      // blanco; se conserva la pregunta actual y se avisa al usuario.
      if (!question || !question.id) {
        this.currentQuestion = previousQuestion;
        this.$bvToast.toast(
          "No se pudo cargar la pregunta. Vuelve a intentarlo.",
          {
            title: "Error",
            variant: "danger",
            solid: false,
          }
        );
        return;
      }
      this.currentQuestion = question;
      this.currentQuestionId = question.id;
      this.fetchAndSetCheklistProgress();
    },
    async fetchAndSetCheklistProgress() {
      const { percentage } = await this.getPlaceChecklistProgress({
        place_id: this.$route.params.id,
        checklist_id: this.$route.params.checklistId,
      });
      this.checklistProgress = percentage;
    },
  },
  computed: {
    ...mapGetters({
      checklist: "checklist/checklist",
      questions: "question/questions",
      place: "place/place",
      placeUsers: "place/placeUsers",
      currentUser: "auth/currentUser",
      placeChecklist: "place/placeChecklist",
    }),
    breadcrumb() {
      if (this.place) {
        return [
          {
            path: "/app/projects",
            text: "Proyectos",
          },
          {
            path: `/app/projects/${this.place.project.id}/places`,
            text: this.place.project.name,
          },
          {
            path: `/app/places/${this.$route.params.id}/checklists`,
            text: this.place.name,
          },
        ];
      }
      return [
        {
          path: "/app/projects",
          text: "Proyectos",
        },
      ];
    },
    currentPlaceUser() {
      if (this.currentUser) {
        return this.placeUsers.find(
          (placeUser) => placeUser.customuser.id == this.currentUser.id
        );
      }
      return null;
    },
  },
};
</script>
<style></style>
